import { Stack } from '@mui/material';
import { PageHeaderStatic, WidgetIcon } from '@procureai/ui-mui';

import { BaseDomainType } from '~/common/types';
import { BasePageTitle } from '~/components/BasePageTitle/BasePageTitle';
import { DataGridQueryBuilder, useDataGridQueryBuilderQuery } from '~/components/DataGridQueryBuilder';
import { DataGridWidget } from '~/components/DataGridWidget';
import { DomainIcon } from '~/components/DomainIcon/DomainIcon';
import { Filters, FilterSaveStatus, useFilters } from '~/components/Filters';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { RouteId } from '~/routes';

import { useContractDataGridConfig } from './ContractList.dataGrid';
import { BASE_CONTRACT_LIST_QUERY } from './ContractList.gql';
import { useContractDataGridQueryBuilderConfig } from './ContractList.queryBuilder';

const domain = BaseDomainType.CONTRACT;

export const ContractList = () => {
  const { queryId, query, onQueryChange, onQueryIdChange, rulesTotal, loading } = useDataGridQueryBuilderQuery({
    domain,
  });
  const { onFilterSave, saveStatus, selected, ...filtersProps } = useFilters({ domain, queryId });

  return (
    <PageLayout
      fullHeight
      renderHeader={
        <>
          <PageHeaderStatic
            title={<BasePageTitle domain={domain} />}
            maxWidth={false}
            icon={<WidgetIcon icon={<DomainIcon domain={domain} />} />}
            right={
              <Stack
                spacing={3}
                direction="row"
                sx={{
                  overflow: 'hidden',
                  alignItems: 'center',
                }}
              >
                <Filters
                  {...filtersProps}
                  selected={selected}
                  onFilterSelect={(filter) => {
                    onQueryIdChange(filter.queryId);
                  }}
                />
              </Stack>
            }
          />
          <DataGridQueryBuilder
            query={query}
            clearDisabled={rulesTotal === 0}
            saveDisabled={saveStatus === FilterSaveStatus.DISABLED}
            onQueryChange={onQueryChange}
            onSave={onFilterSave}
            selectedFilterName={selected?.name}
            useConfig={useContractDataGridQueryBuilderConfig}
          />
        </>
      }
    >
      <DataGridWidget
        domain={domain}
        loading={loading}
        filter={query}
        filterCount={rulesTotal}
        useConfig={useContractDataGridConfig}
        initialNavigateDetail={({ row }) => ({ to: RouteId.contractDetail(row.id) })}
        loadingProps={{
          query: BASE_CONTRACT_LIST_QUERY,
          getNodes: (data) => data.contracts.nodes,
          getTotalCount: (data) => data.contracts.totalCount || 0,
        }}
      />
    </PageLayout>
  );
};
